exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfooter[data-v-cbeb59d2] {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  color: white;\n  font-size: 10px;\n}\nfooter a[data-v-cbeb59d2] {\n    color: #fc0;\n    margin-left: 0.5em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?-url!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cbeb59d2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MyFooter.vue
// module id = 51
// module chunks = 0